var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#3A5DAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8306 14.8208C31.8306 17.316 29.8067 19.3398 27.3116 19.3398H9.89359C8.94028 19.3398 8.16721 18.5668 8.16721 17.6135V16.7014H27.3116C28.3518 16.7014 29.1943 15.8588 29.1943 14.8187V12.684C29.1943 11.6439 28.3518 10.8013 27.3116 10.8013H14.2562V12.4321H26.5559V14.0022C26.5559 14.5907 26.0782 15.0684 25.4897 15.0684H14.4126C12.8708 15.0684 11.62 13.8176 11.62 12.2758V8.16504H27.3116C29.8067 8.16504 31.8306 10.1889 31.8306 12.684V14.8208ZM31.8306 25.177C31.8306 22.6819 29.8067 20.658 27.3116 20.658H9.89359C8.94028 20.658 8.16721 21.4311 8.16721 22.3844V23.2964H27.3116C28.3518 23.2964 29.1943 24.139 29.1943 25.1792V27.3138C29.1943 28.354 28.3518 29.1965 27.3116 29.1965H14.2562V27.5657H26.5559V25.9957C26.5559 25.4072 26.0782 24.9294 25.4897 24.9294H14.4126C12.8708 24.9294 11.62 26.1802 11.62 27.722V31.8328H27.3116C29.8067 31.8328 31.8306 29.8089 31.8306 27.3138V25.177Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.3fdd98ba4f5bed96fc0cc8aa2c35dbcb.svg";
export { ForwardRef as ReactComponent };